import { WSElement, WSText } from "@wingspanhq/fe-component-library";
import { useEffect } from "react";
import { sendMessageToParent } from "../utils/postMessage";

type Props = {
  message: string;
};

export const EmbeddedError: React.FC<Props> = props => {
  useEffect(() => {
    sendMessageToParent("error", { message: props.message });
  }, []);

  return (
    <WSElement p="M">
      <WSText.ParagraphSm color="gray500">{props.message}</WSText.ParagraphSm>
    </WSElement>
  );
};
